import React from 'react';
import Styles from './styles.js';
import Link from 'next/link';
const ChooseNeighbour = ({ imgsrc, title, discription, reverse, href }) => {
  return (
    <>
      <div className="mt-3"></div>
      {reverse == 'true' ? (
        <div className="lg:container mx-auto pb-4">
          <div className="row justify-center px-2 lg:px-0  2xl:px-4">
            <div className="col-md-12 2xl:px-3">
              <div className="grid grid-cols-2 mb-4  gap-x-12 gap-y-4 md:gap-y-0">
                <div className=" order-1 md:order-3 ">
                  <Link href={href}>
                    <a>
                      <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
                    </a>
                  </Link>
                </div>
                <div className=" mt-0 order-2 mt-md-0">
                  <h1
                    className="text-[24px] leading-[30px] font-normal   pt-2 mt-3 mb-1"
                    style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                    {title}
                  </h1>
                  <p
                    className="f-5-responsive mt-2 text-[20px] laeding-[30px] "
                    style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px' }}>
                    {discription}
                  </p>
                  <Link href={href}>
                    <button
                      type="button"
                      className="btn fs-16-18 rounded-0 mt-4"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        padding: '13px 30px',
                      }}>
                      Explore
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="lg:container mx-auto pb-8">
          <div className="row justify-center px-2 lg:px-0 2xl:px-4">
            <div className="col-md-12 2xlpx-3">
              <div className="grid grid-cols-2 mb-5 gap-x-12  ">
                <div className=" order-1 ">
                  <Link href={href}>
                    <a>
                      <img loading="lazy" className="img img-fluid w-full" src={imgsrc} alt="" />
                    </a>
                  </Link>
                </div>
                <div className=" mt-3 order-2 md:mt-0">
                  <h1
                    className="text-[24px] leading-[30px]  font-normal pt-2  mt-3 mb-1"
                    style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                    {title}
                  </h1>
                  <p
                    className="text-[20px] leading-[30px] mt-2 "
                    style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px' }}>
                    {discription}
                  </p>
                  <Link href={href}>
                    <button
                      type="button"
                      className="btn fs-16-18 rounded-0 mt-4"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        padding: '13px 30px',
                      }}>
                      Explore
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles/>
    </>
  );
};

export default ChooseNeighbour;
